export function Page2() {
  return (
    <h1>Page 2</h1>
  )
}
